// Find more keys: https://keycode.info/ and use event.key for these constants

export const ENTER = "Enter";
export const ESCAPE = "Escape";
export const KEY_UP = "ArrowUp";
export const KEY_DOWN = "ArrowDown";
